/**
 * El color de la prioridad en las tarjetas de solicitud.
 *
 * El de `alta` sale del diseño; los otros tres siguen la misma escala que ya
 * usaba la pastilla de urgencia, para no estrenar una paleta nueva por tres
 * casos que el diseño no dibujó.
 *
 * Vive aquí y no dentro de una pantalla porque lo usan las dos que muestran
 * solicitudes —el listado y la bandeja— y se estaban copiando.
 */
export const colorDePrioridad = (prioridad?: string | null): string => {
  const colores: Record<string, string> = {
    baja: '#16A34A',
    media: '#D97706',
    alta: '#DE624D',
    urgente: '#DC2626',
  }
  return colores[prioridad ?? ''] ?? '#6A6B6C'
}
